export default __webpack_public_path__ + "static/media/soccer-488700_1921.21351656.jpg";